"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var player_1 = __importDefault(require("./state/player"));
exports.useComponentStyles = core_1.makeStyles({
    icon: function (props) { return ({
        color: props.playerColors.active,
        '&:hover': {
            color: props.playerColors.hover,
        },
    }); },
});
var AudioPlayControl = function (_a) {
    var playerStatus = _a.playerStatus, playerColors = _a.playerColors, pauseAudio = _a.pauseAudio, playAudio = _a.playAudio, replayAudio = _a.replayAudio, _b = _a.icons, icons = _b === void 0 ? {} : _b, _c = _a.classNames, classNames = _c === void 0 ? {} : _c;
    var _d = icons.PlayIcon, PlayIcon = _d === void 0 ? icons_1.PlayCircleFilledWhite : _d, _e = icons.ReplayIcon, ReplayIcon = _e === void 0 ? icons_1.Replay : _e, _f = icons.PauseIcon, PauseIcon = _f === void 0 ? icons_1.PauseCircleFilled : _f;
    var classes = exports.useComponentStyles({ playerColors: playerColors });
    switch (playerStatus) {
        case player_1.default.STATUS.PLAY:
            return (React.createElement(PauseIcon, { fontSize: "large", onClick: pauseAudio, className: classnames_1.default(classes.icon, classNames.pauseIcon) }));
        case player_1.default.STATUS.STOP:
            return (React.createElement(ReplayIcon, { fontSize: "large", onClick: replayAudio, className: classnames_1.default(classes.icon, classNames.replayIcon) }));
        default:
            return (React.createElement(PlayIcon, { fontSize: "large", onClick: playAudio, className: classnames_1.default(classes.icon, classNames.playIcon) }));
    }
};
exports.default = React.memo(AudioPlayControl);
//# sourceMappingURL=AudioPlayControl.js.map